// extracted by mini-css-extract-plugin
export default {"header_tag":"header_link_header_tag__wXNCd"};